// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_SalvarFranquiasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /instagram/accounts/salvar_franquias
 *
 * Echoes back the instagram_account_id whose franchise associations were
 * updated, so the frontend can confirm the right record was touched.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface InstagramAccounts_SalvarFranquiasResponseDados {
instagram_account_id: number
}

export type InstagramAccounts_SalvarFranquiasResponse = ApiResponse<InstagramAccounts_SalvarFranquiasResponseDados>;

registerResponseContract('InstagramAccounts_SalvarFranquiasResponse', {
  instagram_account_id: { type: 'number',  required: true },
})
